import { type CartItem, type DiscountDTO } from 'ecosystem'
import { getProductDiscountPrice } from 'shared-utils'

export const applyDiscountToCart = (cartItems: CartItem[], discountCode: DiscountDTO) => {
  return cartItems.map((cartItem) => {
    if (cartItem.type === 'SINGLE') {
      const { discountedPrice } =
        getProductDiscountPrice(cartItem.meta.singleType.product, discountCode) ?? {}

      if (discountedPrice) {
        return {
          ...cartItem,
          meta: {
            singleType: {
              ...cartItem.meta.singleType,
              product: {
                ...cartItem.meta.singleType.product,
                price: discountedPrice
              }
            }
          }
        }
      }

      return cartItem
    }

    const updatedItems = cartItem.meta.groupType.items.map((groupItem) => {
      const { discountedPrice } = getProductDiscountPrice(groupItem.product, discountCode) ?? {}

      if (discountedPrice) {
        return {
          ...groupItem,
          product: {
            ...groupItem.product,
            price: discountedPrice
          }
        }
      }

      return groupItem
    })

    return {
      ...cartItem,
      meta: {
        groupType: {
          ...cartItem.meta.groupType,
          items: updatedItems
        }
      }
    }
  })
}
